import { 
    FormControl, 
    FormLabel, 
    Input, 
    Button, 
    VStack , 
    InputGroup, 
    InputRightElement, 
    IconButton, 
    HStack,
    FormErrorMessage
} from "@chakra-ui/react"
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import useLoginForm from "./useLoginForm";

const LoginForm = () => {

    const {
        show,  
        values, 
        errors,
        touched, 
        setShow,
        handleChange,
        handleSubmit 
    } = useLoginForm()

    return(
        <form onSubmit={handleSubmit}>
            <VStack>
                <FormControl isInvalid={errors.UserCode !== undefined && touched.UserCode}>
                    <FormLabel fontSize="sm" mb={0}>Usuario</FormLabel>
                    <Input name="UserCode" type="text" value={values.UserCode} onChange={handleChange}/>
                    <FormErrorMessage>{errors.UserCode}</FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={errors.password !== undefined && touched.password}>
                    <FormLabel fontSize="sm" mb={0}>Contraseña</FormLabel>
                    <InputGroup>
                         <Input name="password" type={show ? "text" : "password"} value={values.password} onChange={handleChange}/>
                         <InputRightElement>
                            <IconButton 
                                aria-label="Show password" 
                                icon={show ? <FaRegEyeSlash size={22}/> :  <FaRegEye size={22}/> } 
                                onClick={setShow}
                                variant="ghost"
                                colorScheme="gray"
                            />
                         </InputRightElement>
                    </InputGroup>
                    <FormErrorMessage>{errors.password}</FormErrorMessage>
                </FormControl>
            </VStack>
            <HStack mt={4} justifyContent="end">
                <Button type="submit" colorScheme="blue">Ingresar</Button>
            </HStack>
        </form>
    )
}

export default LoginForm;